import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, filter, map, take, timeout } from 'rxjs/operators';

import { AuthService } from '@frontend/common';

@Injectable({ providedIn: 'root' })
export class AdminRoleGuard implements CanActivate, CanActivateChild {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): boolean | Promise<boolean> | Observable<boolean | UrlTree> {
    return this.checkAdminRole();
  }

  canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): boolean | Promise<boolean> | Observable<boolean | UrlTree> {
    return this.checkAdminRole();
  }

  private checkAdminRole(): Observable<boolean | UrlTree> {
    return this.authService.user.pipe(
      filter((user) => user !== undefined),
      take(1),
      map((user) => {
        const isAuthenticated = !!user;

        if (!isAuthenticated) {
          return this.router.createUrlTree(['/login']);
        }

        if (this.authService.checkRole('Admin')) {
          return true;
        }

        return this.router.createUrlTree(['/']);
      }),
      timeout(15000),
      catchError(() => of(this.router.createUrlTree(['/login']))),
    );
  }
}
